@for (button of buttons; track button; let last = $last; let first = $first) {
  <fin-text-toggle-button
    [ariaLabel]="button.ariaLabel"
    [selected$]="(activeButtonName | async) === button.name | finToObservable"
    (toggle)="onToggle(button.name)"
    [name]="button.name"
    [text]="button.text"
    [translationPrefix]="translationPrefix"
    [ariaPrefix]="ariaPrefix"
  ></fin-text-toggle-button>
}
